import icon from 'vue-svgicon';

icon.register({
    'regular/send-email-monitor': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13.673 23.25H8.827l.808-4.5h3.231l.807 4.5zM6.404 23.25h9.692M.75 14.25h21M21.75 14.25v1.5a3 3 0 0 1-3 3h-15a3 3 0 0 1-3-3v-12a3 3 0 0 1 3-3h15a2.99 2.99 0 0 1 1.342.316"/><path pid="1" d="M22.244 9.75a1.963 1.963 0 0 1-1.823 1.5h-7.5a1.061 1.061 0 0 1-1.027-1.5l1.418-4.5a2.16 2.16 0 0 1 1.866-1.5h6.965a1.137 1.137 0 0 1 1.07 1.5z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="2" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13.993 4.253l3.428 3.997 5.617-3.996M5.25 11.25h1.5M5.25 8.25h3M5.25 5.25h5.25"/>`,
    },
});
